export default __webpack_public_path__ + "static/ben-mauro-evolution-a9ae9751780530357b932a82e858e7fb.png";